import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { BaseEntityResponseDto } from '@sphere/shared/domain'
import { ActivityVisibility } from '../../../enums'

export class LearningPathResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  title!: string

  @ApiPropertyOptional({ type: 'string', nullable: true })
  description!: string | null

  @ApiProperty({ type: 'string' })
  subjectExternalId!: string

  @ApiProperty({ type: 'string' })
  classLevelExternalId!: string

  @ApiProperty({ enum: ActivityVisibility })
  visibility!: ActivityVisibility

  @ApiPropertyOptional({ type: 'string', nullable: true })
  establishmentId!: string | null

  @ApiProperty({ type: 'string' })
  authorUserId!: string
}
